import {
  BigPrice,
  BoardContainer,
  ChartContainer,
  ChartLabel,
  ColoredBox,
  DailyBoard,
  DashBoardBody,
  DashBoardBodyColSpan,
  DashBoardCard,
  DashBoardHeader,
  DashBoardWrap,
  LastThirtyDaysItem,
  PieChart,
  PieChartCentered,
  PieChartContainer,
  PieChartTap,
  Price,
  RevenueBoard,
  TitleContainer
} from "../../assets/GlobalStyles";
import {ResponsivePie} from '@nivo/pie'
import {ResponsiveBar} from "@nivo/bar";
import React, {useCallback, useEffect, useState} from "react";
import {atom, useAtom, useAtomValue} from "jotai";
import {mediaSearchInfo} from "../media_manage/entity/common";
import {lastMonthAtom, revenueAtom, thisMonthAtom} from "./entity";
import {
  dashboardPeriodStatus,
  dashboardRevenue,
  dashboardRevenueShare,
  dashboardThisMonth
} from "../../services/dashboard/DashboardAdminAxios";
import {AdminInfo} from "../layout";
import {
  dateFormat,
  decimalFormat,
} from "../../common/StringUtils";
import {tokenResultAtom} from "../login/entity";
import {accountUserProfile} from "../../services/account/AccountAdminAxios";
import {
  dashboardUserPeriodStatus,
  dashboardUserRevenue,
  dashboardUserRevenueShare,
  dashboardUserThisMonth
} from "../../services/dashboard/DashboardUserAxios";
import styled from "styled-components";
import {Link} from "react-router-dom";
import DashboardDateSelector from "../../components/dashboard/DateSelector";
import {
  selectAdminStaticsInventory,
  selectUserStaticsInventory,
} from "../../services/reports/inventoryAxios";
import {
  selectAdminStaticsAll,
  selectUserStaticsAll,
} from "../../services/reports/periodAxios";
import {selNoticeList} from "../../services/notice/NoticeAxios";
import {
  columnNoticeDashboard
} from "../customer/entity/NoticeEntity";
import Table from "../../components/table";
import {dataTotalInfo} from "../../components/common/entity";
import NoticeTable from "../../components/table/NoticeTable";
import {selUserList} from "../../services/platform/ManageUserAxios";
import {
  columnUserData,
  searchAccountInfo
} from "../platform_manage/entity/common";
import moment from "moment/moment";

export const MediaSearchInfo = atom(mediaSearchInfo)
const getPercentageChange = (currentValue, previousValue) => {
  const current = Number(currentValue) || 0;
  const previous = Number(previousValue) || 0;
  const value = previous !== 0
      ? Math.abs(((current - previous) / previous * 100).toFixed(2))
      : 0;
  const direction = current > previous ? 'up' : current < previous ? 'down' : 'flat';
  return {direction, value};
};

const revenueFormat = value => decimalFormat(Math.round(Number(value) || 0));

const activeBottomStyle = {borderBottomWidth:'3px', borderBottomColor: 'var(--theme-primary)', color: 'var(--theme-main)'}
function StatusGlyph({name}) {
  const props = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  switch (name) {
    case "request":
      return <svg {...props}><path d="M4 5h16v14H4z"/><path d="M8 9h8M8 13h5"/></svg>;
    case "exposure":
      return <svg {...props}><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5"/></svg>;
    case "revenue":
      return <svg {...props}><circle cx="12" cy="12" r="9"/><path d="M8 9h8M9 6l3 12 3-12"/></svg>;
    case "rate":
      return <svg {...props}><path d="m5 17 4-4 3 3 7-8"/><path d="M14 8h5v5"/></svg>;
    default:
      return null;
  }
}
/** 수익금현황 **/
function RevenueStatus (props) {
  const {role, userId} = props
  const [revenue, setRevenue] = useAtom(revenueAtom)
  useEffect(() => {
    if(role === 'NORMAL'){
      dashboardUserRevenue(userId).then(response => {
        if(response){
          setRevenue(response)
        }
      })
    } else {
      dashboardRevenue(userId).then(response => {
        if(response){
          setRevenue(response)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId,role]);

  const revenueChange = getPercentageChange(revenue.todayAmount, revenue.yesterdayAmount)

  const amountData = [
    {name:'어제',value:revenue.yesterdayAmount},
    {
      name:'지난 7일 평균',
      value:Math.round(Number(revenue.last7daysAmount || 0) / 7),
    },
    {
      name:'이번 달 평균',
      value:Math.round(Number(revenue.thisMonthAmount || 0) / moment().date()),
    },
  ]

  return(
      <DashBoardCard>
        <DashBoardHeader>수익금 현황</DashBoardHeader>
        <DashBoardBody>
          <RevenueBoard>
            <div>오늘</div>
            <div>
              <div>
                <span className={'won'}>{revenueFormat(revenue.todayAmount)}</span>
              </div>
              <RevenueChangeBadge $direction={revenueChange.direction}>
                <RevenueChangeIcon $direction={revenueChange.direction} aria-hidden="true">
                  {revenueChange.direction === 'flat'
                    ? <path d="M5 12h14"/>
                    : <><path d="m6 14 6-6 6 6"/><path d="M12 8v10"/></>}
                </RevenueChangeIcon>
                <strong>{revenueChange.value.toFixed(2)}%</strong>
              </RevenueChangeBadge>
            </div>
          </RevenueBoard>
          <DailyBoard>
            {amountData.map((item, key) => {
              return (
                  <div key={key}>
                    <div>{item.name}</div>
                    <Price className={'won'}>{revenueFormat(item.value)}</Price>
                  </div>
              )
            })}
          </DailyBoard>
        </DashBoardBody>
      </DashBoardCard>
  )
}
/** 이번달 현황 **/
function MonthStatus (props) {
  const {role, userId} = props
  const [thisMonth, setThisMonth] = useAtom(thisMonthAtom)
  const revenue = useAtomValue(revenueAtom)
  useEffect(() => {
    if(role === 'NORMAL') {
      dashboardUserThisMonth(userId).then(response => {
        if (response) {
          setThisMonth(response)
        }
      })
    } else {
      dashboardThisMonth(userId).then(response => {
        if (response) {
          setThisMonth(response)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId,role]);

  const thisMonthData = [
    {name:'요청 수',value:thisMonth.requestCount},
    {name:'노출 수',value:thisMonth.exposureCount},
    //{name:'클릭수',value:thisMonth.validClickCount}
  ]
  const enhancedThisMonthData = [
    ...thisMonthData.slice(0, 0),
    {name: '요청 수', value: thisMonth.requestCount, code: 'count', icon: 'request'},
    {name: '노출 수', value: thisMonth.exposureCount, code: 'count', icon: 'exposure'},
    {name: '수익금', value: revenue.thisMonthAmount, code: 'won', icon: 'revenue'},
    {
      name: '게재율',
      value: Number(thisMonth.requestCount) > 0
          ? (Number(thisMonth.exposureCount || 0) / Number(thisMonth.requestCount)) * 100
          : 0,
      code: 'pct',
      icon: 'rate',
    },
  ]

  return (
      <DashBoardCard>
        <DashBoardHeader>이번달 현황</DashBoardHeader>
        <DashBoardBodyColSpan>
          {enhancedThisMonthData.map((item,key) => {
            return (
                <ColoredBox key={key}>
                  <StatusMetricIcon $type={item.icon}>
                    <StatusGlyph name={item.icon}/>
                  </StatusMetricIcon>
                  <div>{item.name}</div>
                  <Price className={item.code}>
                    {item.code === "pct"
                        ? Number(item.value || 0).toFixed(2)
                        : item.code === "won"
                          ? revenueFormat(item.value)
                          : decimalFormat(item.value)}
                  </Price>
                </ColoredBox>
            )
          })}
        </DashBoardBodyColSpan>
      </DashBoardCard>
  )
}

const aggregateMonthlyStatistics = response => {
  const rows = response?.content ?? response?.rows ?? [];
  const totals = (Array.isArray(rows) ? rows : []).reduce(
      (result, row) => ({
        revenueAmount: result.revenueAmount + Number(row?.revenueAmount ?? 0),
        requestCount: result.requestCount + Number(row?.requestCount ?? 0),
        exposureCount: result.exposureCount + Number(row?.exposureCount ?? 0),
      }),
      {revenueAmount: 0, requestCount: 0, exposureCount: 0}
  );
  return {
    ...totals,
    exposureRate: totals.requestCount > 0
        ? (totals.exposureCount / totals.requestCount) * 100
        : 0,
  };
};

const getLastMonthCondition = () => ({
  currentPage: 1,
  pageSize: 30,
  searchStartDate: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
  searchEndDate: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
  productType: null,
  targetingType: null,
  exchangeSearchType: null,
  deviceType: null,
  agentType: ["WEB", "WEB_APP", "MOBILE_WEB", "MOBILE_HYBRID_APP", "MOBILE_NATIVE_APP"],
  sortType: "DATE_DESC",
});

async function dashboardUserLastMonth(userId) {
  const response = await selectUserStaticsAll(userId, getLastMonthCondition());
  return aggregateMonthlyStatistics(response);
}

async function dashboardLastMonth(userId) {
  const response = await selectAdminStaticsAll(userId || undefined, getLastMonthCondition());
  return aggregateMonthlyStatistics(response);
}

/** 지난달 현황 **/
function LastMonth (props) {
  const {role, userId} = props
  const [lastMonth, setLastMonth] = useAtom(lastMonthAtom)
  const getExposureRate = (data) => {
    if (!data?.requestCount || data.requestCount === 0) {
      return 0;
    }

    return Math.abs((data.exposureCount / data.requestCount) * 100).toFixed(2);
  };

  useEffect(() => {
    if(role === 'NORMAL') {
      dashboardUserLastMonth(userId).then(response => {
        if (response) {
          setLastMonth({
            ...response,
            exposureRate: getExposureRate(response),
          });
        }
      })
    } else {
      dashboardLastMonth(userId).then(response => {
        if (response) {
          setLastMonth({
            ...response,
            exposureRate: getExposureRate(response),
          });
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId,role]);
  const lastMonthData = [
    {name: "수익금", value:lastMonth.revenueAmount, code: 'won'},
    {name: "요청 수", value:lastMonth.requestCount, code: 'count'},
    {name: "노출 수", value:lastMonth.exposureCount, code: 'count'},
    {name: "게제율", value:lastMonth.exposureRate, code: 'pct'},
    //{name: "클릭 수", value:lastMonth.validClickCount},
  ]
  const lastMonthDisplayData = [
    lastMonthData[1],
    lastMonthData[2],
    lastMonthData[0],
    lastMonthData[3],
  ]
  return (
      <DashBoardCard>
        <DashBoardHeader>지난달 현황</DashBoardHeader>
        <DashBoardBody style={{height: '100%'}}>
          <DashBoardWrap>
            {lastMonthDisplayData.map((item, key) => {
              return (
                  <LastThirtyDaysItem key={key}>
                    <div>
                      <StatusMetricIcon $type={["request", "exposure", "revenue", "rate"][key]}>
                        <StatusGlyph name={["request", "exposure", "revenue", "rate"][key]}/>
                      </StatusMetricIcon>
                    </div>
                    <div>
                      <div>{item.name}</div>
                      <BigPrice className={item.code}>
                        {item.code === "pct"
                            ? Number(item.value || 0).toFixed(2)
                            : item.code === "won"
                              ? revenueFormat(item.value)
                            : decimalFormat(item.value)}
                      </BigPrice>
                    </div>
                  </LastThirtyDaysItem>
              )
            })}
          </DashBoardWrap>
        </DashBoardBody>
      </DashBoardCard>
  )
}
/** 수익금 점유율 **/
function RevenueShare (props) {
  const {role, userId, dateRange} = props
  const [loading, setLoading] = useState(true)
  const [shareData, setShareData] = useState({
    product: [],
    device: [],
  })

  useEffect(() => {
    let active = true
    const requestRevenueShare = type => role === 'NORMAL'
        ? dashboardUserRevenueShare(type, userId, dateRange)
        : dashboardRevenueShare(type, userId, dateRange)

    setLoading(true)
    setShareData({product: [], device: []})
    Promise.all([
      requestRevenueShare('PRODUCT'),
      requestRevenueShare('DEVICE'),
    ]).then(([product, device]) => {
      if (!active) return
      setShareData({
        product: Array.isArray(product) ? product : [],
        device: Array.isArray(device) ? device : [],
      })
    }).finally(() => {
      if (active) {
        setLoading(false)
      }
    })

    return () => {
      active = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dateRange.endDate, dateRange.startDate, userId, role])

  return (
      <DashBoardCard>
        <DashBoardHeader>수익금 점유율</DashBoardHeader>
        <DashBoardBody>
          {loading ? (
            <DashboardLoading>
              <LoadingSpinner aria-hidden="true"/>
              <span>점유율 데이터를 불러오는 중입니다.</span>
            </DashboardLoading>
          ) : (
          <RevenueShareGrid>
            <RevenueSharePanel>
              <RevenueShareTitle>광고상품별</RevenueShareTitle>
              <MyResponsivePie data={shareData.product}/>
            </RevenueSharePanel>
            <RevenueSharePanel>
              <RevenueShareTitle>디바이스별</RevenueShareTitle>
              <MyResponsivePie data={shareData.device}/>
            </RevenueSharePanel>
          </RevenueShareGrid>
          )}
        </DashBoardBody>
      </DashBoardCard>
  )
}

/** 사용자 정보 **/
function UserList (props) {
  const [tokenUserInfo] = useAtom(tokenResultAtom)

  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);

  const [userInfoList, setUserInfoList] = useState(null)

  const loadData = useCallback(() => {
    if (tokenUserInfo.role !== 'NORMAL') {
      selUserList(searchAccountInfo).then(response => {
        if (response !== null) {
          const list = response?.content ?? [];
          const since = moment().subtract(24 * 7, 'hours');

          const recentUsers = list.filter(u =>
              moment(u.createdAt).isSameOrAfter(since)
          );

          setUserInfoList(recentUsers);
          setTotalInfo({
            totalCount: recentUsers.length,
            totalPages: response?.totalPages,
            currentPage: response?.pageNumber,
          });
        }
      });
    }
  }, [tokenUserInfo.role]);

  useEffect(() => {
    loadData();
  }, [loadData]);


  return (
      <UserStatusCard>
        <DashBoardHeader>신규 가입 등록 현황 (최근 7일)</DashBoardHeader>
        <DashBoardBody>
          <Table columns={columnUserData}
                 totalCount={[totalInfo.totalCount, '매체']}
                 showHoverRows={false}
                 headerHeight={44}
                 style={{minHeight: 260}}
                 emptyText={'신규 가입자가 없습니다.'}
                 data={userInfoList !== null ? userInfoList : []}/>
        </DashBoardBody>
      </UserStatusCard>
  )
}
/** 공지사항 **/
function NoticeUser (props) {
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);
  const [, setIsSearch] = useState(false);
  const [searchCondition, ] = useState({keyword:'', pageSize: 10, currentPage: 1, publishYn:'ALL'});

  const dataSource = useCallback(({skip, limit}) => {
    const params = {
      ...searchCondition,
      currentPage: skip / limit === 0 ? 1 : skip / limit + 1,
      pageSize: limit,
    };

    if (tokenUserInfo.role === 'NORMAL') {
      return selNoticeList({...params, publishYn: 'Y'}).then(response => {
        const totalCount = response.totalElements;

        setIsSearch(false);
        setTotalInfo({
          totalCount: totalCount,
          currentCount: response?.content.length,
          currentPage: response.pageNumber,
          totalPages: response.totalPages,
        });

        return {
          data: response?.content,
          count: parseInt(totalCount),
        };
      });
    }

    return Promise.resolve({
      data: [],
      count: 0,
    });
  }, [searchCondition, tokenUserInfo.role]);

  return (
      <NoticeStatusCard>
        <DashBoardHeader>공지사항</DashBoardHeader>
        <DashBoardBody>
          <NoticeTable
              columns={tokenUserInfo.role !== 'NORMAL' ? columnNoticeDashboard : columnNoticeDashboard.filter(column => column.name !== 'publishYn')}
              totalCount={[totalInfo.currentCount, '공지사항']}
              defaultLimit={searchCondition.pageSize}
              data={dataSource}
              style={{textAlign: 'start', border: 'none', minHeight: 100}}
              pagination={false}
              livePagination={false}
          />
        </DashBoardBody>
      </NoticeStatusCard>
  )
}
/** 일자별 차트 **/
function MyResponsiveBar(props) {
  const {
    role,
    dataType,
    userId,
    dateRange,
    seriesColor = "var(--theme-primary)",
    showAxes = true,
    showEmptyState = false,
    onTotal,
  } = props;
  const [revenuePeriod, setRevenuePeriod] = useState([]);

  useEffect(() => {
    if(role === 'NORMAL'){
      dashboardUserPeriodStatus(dataType, userId).then(response => {
        if (response) {
          setRevenuePeriod(response)
        }
      })
    } else {
      dashboardPeriodStatus(dataType, userId).then(response => {
        if (response) {
          setRevenuePeriod(response)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, dataType, role]);

  const normalizeChartDate = item => {
    const rawDate = item?.date ?? item?.historyDate ?? item?.statDate;
    if (rawDate == null) {
      return null;
    }

    const rawText = String(rawDate);
    const compactDate = rawText.replace(/[^0-9]/g, "").slice(0, 8);
    const parsedDate = moment(compactDate, "YYYYMMDD", true);
    return parsedDate.isValid() ? parsedDate : null;
  };

  const normalizedRevenuePeriod = (Array.isArray(revenuePeriod) ? revenuePeriod : [])
  .map(item => {
    const parsedDate = normalizeChartDate(item);
    if (!parsedDate) {
      return null;
    }
    return {
      ...item,
      date: parsedDate.format("YYYY-MM-DD"),
    };
  })
  .filter(Boolean);

  const filteredRevenuePeriod = normalizedRevenuePeriod.filter(item => {
    if (!dateRange?.startDate || !dateRange?.endDate) {
      return true;
    }
    return moment(item.date, "YYYY-MM-DD", true)
    .isBetween(dateRange.startDate, dateRange.endDate, "day", "[]");
  });

  const dateFormatted = (tick) => {
    let value;
    if (filteredRevenuePeriod.length > 31) {
      value = tick.tickIndex%5 === 0 ? tick.value : null
    } else {
      value = tick.value
    }
    return dateFormat(value, 'MM.DD')
  }
  const tickComponent = (tick) => {
    return (
        <g
            transform={`translate(${tick.x},${tick.y})`}
        >
          <line />
          <text
              textAnchor="middle"
              dominantBaseline="middle"
              transform={`translate(${tick.textX}, ${tick.textY})`}
              fontSize={9}
          >
            {dateFormatted(tick)}
          </text>
        </g>
    );
  };

  const lineValueKey = 'count';

  const LineLayer = ({ xScale, yScale }) => {
    const bandwidth = typeof xScale.bandwidth === 'function' ? xScale.bandwidth() : 0;

    const points = filteredRevenuePeriod
    .filter((item) => item?.date != null)
    .map((item) => {
      const v = Number(item?.[lineValueKey] ?? 0);
      const x = xScale(item.date);

      if (x == null) return null;

      return {
        x: x + bandwidth / 2,
        y: yScale(v), // 0이면 yScale(0)으로 바닥선에 맞게 감
        v,
      };
    })
    .filter(Boolean);

    if (points.length < 2) return null;

    const d = points
    .map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`)
    .join(' ');

    return (
        <g>
          <path
              d={d}
              fill="none"
              stroke={seriesColor}
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
          />
          {points.map((p, i) => (
              <g key={i}>
                <circle cx={p.x} cy={p.y} r={4} fill={seriesColor} stroke="#fff" strokeWidth={2} />
              </g>
          ))}
        </g>
    );
  };
  const maxCount = Math.max(
      ...filteredRevenuePeriod.map((item) => Number(item?.count ?? 0)),
      0
  );
  const periodTotal = filteredRevenuePeriod.reduce(
      (total, item) => total + Number(item?.count ?? 0),
      0
  );

  useEffect(() => {
    onTotal?.(dataType, periodTotal);
  }, [dataType, onTotal, periodTotal]);

  if (filteredRevenuePeriod.length === 0) {
    if (!showEmptyState) {
      return null;
    }
    return (
        <ChartEmptyState>
          <ChartEmptyIcon>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 19V9M10 19V5M16 19v-7M22 19H2"/>
            </svg>
          </ChartEmptyIcon>
          <strong>선택한 기간의 데이터가 없습니다.</strong>
          <span>다른 조회기간이나 매체를 선택해 주세요.</span>
        </ChartEmptyState>
    );
  }

  return (
      <ResponsiveBar
          key={`${dataType}-${dateRange?.startDate}-${dateRange?.endDate}`}
          data={filteredRevenuePeriod}
          keys={["count"]}
          indexBy={"date"}
          margin={{top: 24, right: 24, bottom: 42, left: 68}}
          padding={0.2}
          minValue={0}
          maxValue={maxCount === 0 ? 1 : 'auto'}
          valueScale={{type: 'linear', min: 0, max: maxCount === 0 ? 1 : 'auto', nice: true}}
          indexScale={{type: 'band', round: true}}
          colors={["var(--theme-primary-transparent)"]}
          axisLeft={showAxes ? {
            tickSize: 0,
            tickPadding: 10,
            tickValues: 5,
            format: value => decimalFormat(Math.round(Number(value) || 0)),
          } : null}
          animate={true}
          axisBottom={showAxes ? {
            tickSize: 0,
            tickPadding: 15,
            //tickRotation: -45,
            legendOffset: 32,
            renderTick: tickComponent
          } : null}
          tooltip={(props) => {
            return (
                <ChartTooltip>
                  <p className={'date'}>{props.data.date}</p>
                  <p className={dataType !== 'REVENUE_AMOUNT' ? 'count' : 'won'}>
                    {dataType === 'REVENUE_AMOUNT'
                        ? revenueFormat(props.data.count)
                        : decimalFormat(props.data.count)}
                  </p>
                </ChartTooltip>
            )
          }}
          enableLabel={false}
          enableGridY={showAxes}
          gridYValues={5}
          theme={{
            axis: {ticks: {text: {fill: "#8b929a", fontSize: 10}}},
            grid: {line: {stroke: "#edf0f2", strokeWidth: 1}},
          }}
          layers={[
            ...(showAxes ? ['grid', 'axes'] : []),
            'bars',
            LineLayer,      // 선 + 포인트 + 포인트 값 노출
            'markers',
            'legends',
          ]}

      />
  )
}
/** 수익금 점유율 차트 **/
function MyResponsivePie({data = []}){
  const chartColors = [
    'var(--accent-red)',
    'var(--accent-orange)',
    'var(--accent-yellow)',
    'var(--accent-green)',
    'var(--accent-purple)'
  ];
  const pieData = data.map(({selectedTypeName,shareByPer}, index) => ({
    id: selectedTypeName,
    value: shareByPer/100,
    color: chartColors[index % chartColors.length],
  }))
  const totalShare = pieData.reduce(
      (total, item) => total + Number(item.value || 0) * 100,
      0
  )
  const formatArcLabel = datum => {
    const label = String(datum.id || "-");
    const shortLabel = label.length > 7 ? `${label.slice(0, 7)}…` : label;
    return `${shortLabel} ${(Number(datum.value) * 100).toFixed(0)}%`;
  }

  return(
      <RevenueDonutLayout>
        <RevenueDonutCanvas>
          <DonutCenter>
            <strong>{totalShare.toFixed(0)}</strong>
            <small>%</small>
          </DonutCenter>
          <ResponsivePie
              data={pieData}
              margin={{top: 10, right: 10, bottom: 10, left: 10}}
              innerRadius={0.6}
              padAngle={1.2}
              cornerRadius={4}
              activeOuterRadiusOffset={5}
              colors={{datum: 'data.color'}}
              borderWidth={2}
              borderColor="#ffffff"
              enableArcLabels
              arcLabel={formatArcLabel}
              arcLabelsSkipAngle={7}
              arcLabelsTextColor="#ffffff"
              enableArcLinkLabels={false}
              valueFormat={'.1%'}
              theme={{labels:{text:{fontSize:8,fontWeight:750}}}}
              tooltip={({datum}) => (
                <ChartTooltip>
                  <p className="date">{datum.id}</p>
                  <p>{(Number(datum.value) * 100).toFixed(1)}%</p>
                </ChartTooltip>
              )}
          />
        </RevenueDonutCanvas>
        <RevenueLegend>
          {pieData.map(item => (
            <RevenueLegendItem key={item.id}>
              <RevenueLegendLabel>
                <i style={{backgroundColor: item.color}}/>
                <span title={item.id}>{item.id}</span>
              </RevenueLegendLabel>
              <strong>{(Number(item.value) * 100).toFixed(1)}%</strong>
            </RevenueLegendItem>
          ))}
        </RevenueLegend>
      </RevenueDonutLayout>
  )
}

function InventoryTopFive({role, userId, dateRange}) {
  const [inventoryList, setInventoryList] = useState([]);
  const [metricKey, setMetricKey] = useState("revenueAmount");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    const condition = {
      currentPage: 1,
      pageSize: 30,
      searchStartDate: dateRange.startDate,
      searchEndDate: dateRange.endDate,
      productType: null,
      targetingType: null,
      exchangeSearchType: null,
      deviceType: null,
      agentType: ["WEB", "WEB_APP", "MOBILE_WEB", "MOBILE_HYBRID_APP", "MOBILE_NATIVE_APP"],
      sortType: "INVENTORY_NAME_DESC",
    };
    const request = role === "NORMAL"
      ? selectUserStaticsInventory(userId, condition)
      : selectAdminStaticsInventory(userId || undefined, condition);

    setLoading(true);
    setInventoryList([]);
    request
    .then(response => {
      if (!active) {
        return;
      }
      const rows = response?.content ?? response?.rows ?? [];
      setInventoryList(Array.isArray(rows) ? rows : []);
    })
    .finally(() => {
      if (active) {
        setLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, [dateRange.endDate, dateRange.startDate, role, userId]);

  const metrics = [
    {value: "revenueAmount", label: "수익금", unit: "원"},
    {value: "requestCount", label: "요청 수", unit: "건"},
    {value: "exposureCount", label: "노출 수", unit: "건"},
  ];
  const selectedMetric = metrics.find(metric => metric.value === metricKey) ?? metrics[0];
  const rankedInventory = [...inventoryList]
  .sort((first, second) => Number(second?.[metricKey] ?? 0) - Number(first?.[metricKey] ?? 0))
  .slice(0, 5);
  const maximumValue = Math.max(
      ...rankedInventory.map(inventory => Number(inventory?.[metricKey] ?? 0)),
      1
  );

  return (
    <InventoryPanel>
      <InventoryPanelHeader>
        <TrendTitleGroup>
          <TrendTitle>지면별 성과 비교 TOP 5</TrendTitle>
          <TrendDescription>선택한 기간의 상위 지면 성과를 비교합니다.</TrendDescription>
        </TrendTitleGroup>
        <InventoryMetricSelect value={metricKey} onChange={event => setMetricKey(event.target.value)}>
          {metrics.map(metric => (
            <option key={metric.value} value={metric.value}>{metric.label}</option>
          ))}
        </InventoryMetricSelect>
      </InventoryPanelHeader>

      {loading ? (
        <DashboardLoading>
          <LoadingSpinner aria-hidden="true"/>
          <span>지면별 성과를 불러오는 중입니다.</span>
        </DashboardLoading>
      ) : rankedInventory.length === 0 ? (
        <InventoryStatus>선택한 조건의 지면 성과 데이터가 없습니다.</InventoryStatus>
      ) : (
        <InventoryRanking>
          {rankedInventory.map((inventory, index) => {
            const value = Number(inventory?.[metricKey] ?? 0);
            return (
              <InventoryRankRow key={inventory.inventoryId ?? `${inventory.inventoryName}-${index}`}>
                <InventoryRank $rank={index}>{index + 1}</InventoryRank>
                <InventoryInfo>
                  <strong title={inventory.inventoryName}>{inventory.inventoryName || "이름 없는 지면"}</strong>
                  <InventoryBar>
                    <span style={{width: `${Math.max(4, value / maximumValue * 100)}%`}}/>
                  </InventoryBar>
                </InventoryInfo>
                <InventoryValue>
                  {metricKey === "revenueAmount" ? revenueFormat(value) : decimalFormat(value)}
                  <small>{selectedMetric.unit}</small>
                </InventoryValue>
              </InventoryRankRow>
            );
          })}
        </InventoryRanking>
      )}
    </InventoryPanel>
  );
}

const getDefaultDateRange = () => ({
  startDate: moment().startOf("month").format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
});

const trendMetrics = [
  {value: "REQUEST_COUNT", label: "요청 수", color: "var(--accent-red)"},
  {value: "EXPOSURE_COUNT", label: "노출 수", color: "var(--accent-orange)"},
  {value: "REVENUE_AMOUNT", label: "수익금", color: "var(--accent-green)"},
];

/** 대시보드 **/
export default function DashBoard(){
  const [dataType, setDataType] = useState('REVENUE_AMOUNT')
  const [activeMetrics, setActiveMetrics] = useState(() => trendMetrics.map(metric => metric.value))
  const [mediaSearchInfo, setMediaSearchInfo] = useAtom(MediaSearchInfo)
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [adminInfoState, setAdminInfoState] = useAtom(AdminInfo)
  const [mediaOptions, setMediaOptions] = useState([])
  const [dateDraft, setDateDraft] = useState(getDefaultDateRange)
  const [appliedDateRange, setAppliedDateRange] = useState(getDefaultDateRange)
  const [trendTotals, setTrendTotals] = useState({})

  useEffect(() => {
    if (tokenUserInfo.role === "NORMAL") {
      return;
    }

    selUserList(searchAccountInfo).then(response => {
      const users = response?.content ?? response?.rows ?? [];
      setMediaOptions(Array.isArray(users) ? users : []);
    });
  }, [tokenUserInfo.role]);

  const handleChangeChartKey = (type) => {
    setDataType(type)
    setActiveMetrics(current =>
      current.includes(type)
        ? current.filter(metric => metric !== type)
        : [...current, type]
    )
  }
  /**
   * 모달안에 매체 검색 선택시
   */
  const handleSearchResult = (keyword) => {
    //매체 검색 api 호출
    setMediaSearchInfo(mediaSearchInfo)
    if(keyword.id !== undefined) {
      //userId 로 다시 조회 대시보드
      localStorage.setItem('mediaUsername',keyword.username)
      accountUserProfile(keyword.username).then(response => {
        setAdminInfoState({
          ...adminInfoState,
          convertedUser: keyword.username,
          name: keyword.siteName,
          id: keyword.id,
          accountProfile: response !== null
        })
      })
    }
  }

  const handleTrendTotal = useCallback((metricType, total) => {
    setTrendTotals(current => (
      current[metricType] === total
        ? current
        : {...current, [metricType]: total}
    ));
  }, []);

  const handleMediaSelect = event => {
    const selectedUsername = event.target.value;
    if (!selectedUsername) {
      handleClickReset();
      return;
    }

    const selectedMedia = mediaOptions.find(media => media.username === selectedUsername);
    if (selectedMedia) {
      handleSearchResult(selectedMedia);
    }
  }

  const handleDateRangeChange = nextDateRange => {
    setDateDraft(nextDateRange);
    if (nextDateRange.startDate && nextDateRange.endDate) {
      setAppliedDateRange(nextDateRange);
    }
  }

  const handleClickReset = () => {
    localStorage.removeItem("mediaUsername")
    setAdminInfoState({
      ...adminInfoState,
      convertedUser: '',
      name: '',
      id: '',
    })
    const initialDateRange = getDefaultDateRange()
    setDateDraft(initialDateRange)
    setAppliedDateRange(initialDateRange)
    setDataType('REVENUE_AMOUNT')
    setActiveMetrics(trendMetrics.map(metric => metric.value))
    setTrendTotals({})
  }
  return(
      <main>
        <DashboardContainer>
          <DashboardTitleContainer>
            <DashboardTitleArea>
              <h1>대시보드</h1>
              <DashboardDescription>
                매체 운영 현황과 수익 지표를 한눈에 확인할 수 있습니다.
              </DashboardDescription>
            </DashboardTitleArea>
            {tokenUserInfo.role !== 'NORMAL' &&
                <CreateInventoryButton to="/board/media">
                  <span aria-hidden="true">＋</span>
                  지면 생성
                </CreateInventoryButton>
            }
          </DashboardTitleContainer>
          <DashboardGrid>
            <RevenueFullRow>
              <RevenueStatus role={tokenUserInfo.role} userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id} />
            </RevenueFullRow>
            <StatusCardColumn $featured>
              <MonthStatus role={tokenUserInfo.role} userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id}/>
            </StatusCardColumn>
            <StatusCardColumn>
              <LastMonth role={tokenUserInfo.role} userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id}/>
            </StatusCardColumn>
          </DashboardGrid>
          <DashboardFilterPanel>
            {tokenUserInfo.role !== "NORMAL" && (
                <FilterField $media>
                  <FilterControlIcon aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <circle cx="12" cy="7" r="3"/>
                      <path d="M6.5 20v-3.5a5.5 5.5 0 0 1 11 0V20"/>
                    </svg>
                  </FilterControlIcon>
                  <FilterLabel htmlFor="dashboard-media">매체 선택</FilterLabel>
                  <DashboardSelect
                      id="dashboard-media"
                      value={adminInfoState.convertedUser || ""}
                      onChange={handleMediaSelect}
                  >
                    <option value="">매체 전체</option>
                    {mediaOptions.map(media => (
                        <option key={media.id ?? media.username} value={media.username}>
                          {media.siteName || media.managerName1 || media.username}
                        </option>
                    ))}
                  </DashboardSelect>
                </FilterField>
            )}
            <FilterField $date>
              <FilterControlIcon aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <rect x="4" y="5.5" width="16" height="14" rx="2"/>
                  <path d="M8 3v5M16 3v5M4 10h16"/>
                </svg>
              </FilterControlIcon>
              <FilterLabel>조회 기간</FilterLabel>
              <DashboardDateSelector value={dateDraft} onChange={handleDateRangeChange} showIcon={false}/>
            </FilterField>
            <FilterActions>
              <FilterResetButton type="button" onClick={handleClickReset}>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 4v6h6M20 20v-6h-6M5.5 15a7 7 0 0 0 12 2M18.5 9a7 7 0 0 0-12-2"/>
                </svg>
                초기화
              </FilterResetButton>
            </FilterActions>
          </DashboardFilterPanel>
          <DashboardSectionHeader>
            <div>
              <strong>성과 분석</strong>
              <span>선택한 기간의 지표 변화와 상위 지면을 비교합니다.</span>
            </div>
          </DashboardSectionHeader>
          <AnalyticsGrid>
          <TrendPanel>
            <TrendPanelHeader>
              <TrendTitleGroup>
                <TrendTitle>일자별 지표 추이</TrendTitle>
                <TrendDescription>선택한 지표의 일자별 변화와 흐름을 확인합니다.</TrendDescription>
              </TrendTitleGroup>
            </TrendPanelHeader>
            <MetricGrid>
              {trendMetrics.map(metric => (
                <MetricButton
                  key={metric.value}
                  type="button"
                  $active={activeMetrics.includes(metric.value)}
                  $seriesColor={metric.color}
                  aria-pressed={activeMetrics.includes(metric.value)}
                  onClick={() => handleChangeChartKey(metric.value)}
                >
                  <MetricColorDot $active={activeMetrics.includes(metric.value)} $seriesColor={metric.color}/>
                  <MetricText>
                    <span>{metric.label}</span>
                    <small>
                      {metric.value === "REVENUE_AMOUNT"
                        ? `${revenueFormat(trendTotals[metric.value] ?? 0)}원`
                        : decimalFormat(trendTotals[metric.value] ?? 0)}
                    </small>
                  </MetricText>
                </MetricButton>
              ))}
            </MetricGrid>
            <DashBoardHeader>일자별 주요 현황</DashBoardHeader>
            <DashBoardBody>
              <ChartContainer>
                <ChartLabel>
                  <div onClick={() => handleChangeChartKey('REVENUE_AMOUNT')} style={dataType==='REVENUE_AMOUNT' ? activeBottomStyle : null}>수익금</div>
                  <div onClick={() => handleChangeChartKey('REQUEST_COUNT')} style={dataType==='REQUEST_COUNT' ? activeBottomStyle : null}>요청수</div>
                  <div onClick={() => handleChangeChartKey('EXPOSURE_COUNT')} style={dataType==='EXPOSURE_COUNT' ? activeBottomStyle : null}>노출수</div>
                  {/*<div onClick={() => handleChangeChartKey('CLICK_COUNT')} style={dataType==='CLICK_COUNT' ? activeBottomStyle : null}>클릭수</div>*/}
                </ChartLabel>
                <TrendChartStack>
                  {activeMetrics.map((metricType, index) => {
                    const metric = trendMetrics.find(item => item.value === metricType);
                    return (
                      <TrendChartLayer key={metricType}>
                        <MyResponsiveBar
                            role={tokenUserInfo.role}
                            dataType={metricType}
                            userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id}
                            convertedUser={adminInfoState.convertedUser}
                            dateRange={appliedDateRange}
                            seriesColor={metric?.color}
                            showAxes={index === 0}
                            showEmptyState={index === 0}
                            onTotal={handleTrendTotal}
                        />
                      </TrendChartLayer>
                    );
                  })}
                  {activeMetrics.length === 0 && (
                    <ChartEmptyState>
                      <ChartEmptyIcon>
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M4 19V9M10 19V5M16 19v-7M22 19H2"/>
                        </svg>
                      </ChartEmptyIcon>
                      <strong>표시할 지표를 선택해 주세요.</strong>
                      <span>상단의 지표 버튼을 누르면 차트에 표시됩니다.</span>
                    </ChartEmptyState>
                  )}
                </TrendChartStack>
              </ChartContainer>
            </DashBoardBody>
          </TrendPanel>
          <AnalyticsSideColumn>
            <InventoryTopFive
                role={tokenUserInfo.role}
                userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id}
                dateRange={appliedDateRange}
            />
            <RevenueShareColumn>
              <RevenueShare
                  role={tokenUserInfo.role}
                  userId={tokenUserInfo.role === 'NORMAL' ? tokenUserInfo.id : adminInfoState.id}
                  dateRange={appliedDateRange}
              />
            </RevenueShareColumn>
          </AnalyticsSideColumn>
          </AnalyticsGrid>
          <DashboardSectionHeader>
            <div>
              <strong>운영 정보</strong>
              <span>{tokenUserInfo.role === 'NORMAL' ? '최근 공지사항을 확인합니다.' : '최근 등록된 매체 계정을 확인합니다.'}</span>
            </div>
          </DashboardSectionHeader>
          {tokenUserInfo.role !== 'NORMAL' && <UserList/> }
          {tokenUserInfo.role === 'NORMAL' && <NoticeUser/> }
        </DashboardContainer>
      </main>
  )
}

const RevenueDonutLayout = styled.div`
  display: grid;
  width: 100%;
  height: 158px;
  grid-template-columns: minmax(120px, .9fr) minmax(112px, 1fr);
  align-items: center;
  gap: 4px;
  padding: 4px 10px 8px 4px;

  @media (max-width: 620px) {
    height: 166px;
    grid-template-columns: minmax(120px, .9fr) minmax(105px, 1fr);
    padding: 4px 8px 8px 2px;
  }
`;

const RevenueShareGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`;

const RevenueSharePanel = styled.section`
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: #fff;
`;

const RevenueShareTitle = styled.h3`
  margin: 0;
  padding: 11px 12px 0;
  color: #44505d;
  font-size: 11px;
  font-weight: 750;
`;

const RevenueDonutCanvas = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

const DonutCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: flex;
  width: 94px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: none;
  transform: translate(-50%, -50%);

  span {
    margin-bottom: 5px;
    color: #929aa4;
    font-size: 8px;
  }

  strong {
    max-width: 100%;
    overflow: hidden;
    color: #273240;
    font-size: 15px;
    font-weight: 800;
    letter-spacing: -.3px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  small {
    margin-top: 2px;
    color: #8b949f;
    font-size: 8px;
  }
`;

const RevenueLegend = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`;

const RevenueLegendItem = styled.div`
  display: flex;
  min-height: 25px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 6px;
  border-radius: 6px;

  &:hover {
    background: #f7f9fb;
  }

  & > strong {
    flex: 0 0 auto;
    color: #3d4651;
    font-size: 8px;
    font-weight: 750;
  }
`;

const RevenueLegendLabel = styled.span`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;

  i {
    width: 8px;
    height: 8px;
    flex: 0 0 8px;
    border-radius: 3px;
  }

  span {
    overflow: hidden;
    color: #737d89;
    font-size: 9px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const AnalyticsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(310px, .9fr);
  align-items: stretch;
  gap: 18px;
  margin-bottom: 22px;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

const AnalyticsSideColumn = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
`;

const TrendPanel = styled.section`
  display: flex;
  height: 688px;
  min-width: 0;
  flex-direction: column;
  margin-bottom: 0;
  overflow: hidden;
  border: 1px solid #dfe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 41, 55, .06);

  ${DashBoardHeader},
  ${ChartLabel} {
    display: none !important;
  }

  ${DashBoardBody} {
    flex: 1;
    min-height: 0;
    padding: 0;
  }

  ${ChartContainer} {
    height: 100% !important;
    margin-top: 0;
    overflow: hidden;
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  @media (max-width: 700px) {
    height: 600px;

    ${ChartContainer} {
      height: 100% !important;
    }
  }
`;

const InventoryPanel = styled.section`
  height: 336px;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(31, 41, 55, .055);
`;

const InventoryPanelHeader = styled.header`
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #edf0f2;
`;

const InventoryMetricSelect = styled.select`
  width: 82px;
  height: 32px;
  flex: 0 0 auto;
  padding: 0 25px 0 9px;
  border: 1px solid #dfe3e7;
  border-radius: 6px;
  background: #fff;
  color: #555e68;
  font-size: 9px;
  font-weight: 650;

  &:focus {
    border-color: ${({theme}) => theme.color.subColor};
    outline: none;
    box-shadow: 0 0 0 3px var(--theme-primary-focus-ring);
  }
`;

const InventoryRanking = styled.div`
  display: flex;
  min-height: 280px;
  flex-direction: column;
  justify-content: center;
  padding: 10px 14px;
`;

const InventoryRankRow = styled.div`
  display: grid;
  min-height: 52px;
  grid-template-columns: 24px minmax(0, 1fr) 82px;
  align-items: center;
  gap: 9px;
  border-bottom: 1px solid #edf0f2;

  &:last-child {
    border-bottom: 0;
  }
`;

const InventoryRank = styled.span`
  color: ${({$rank}) => ["var(--theme-primary)", "#14B8A6", "#8B5CF6", "#64748B", "#94A3B8"][$rank]};
  font-size: 16px;
  font-weight: 800;
  text-align: center;
`;

const InventoryInfo = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;

  strong {
    overflow: hidden;
    color: #3f4751;
    font-size: 10px;
    font-weight: 650;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const InventoryBar = styled.span`
  display: block;
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf2f7;

  span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, var(--theme-primary-light), var(--theme-primary));
  }
`;

const InventoryValue = styled.strong`
  overflow: hidden;
  color: #36404b;
  font-size: 10px;
  font-weight: 750;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;

  small {
    margin-left: 3px;
    color: #9299a1;
    font-size: 8px;
    font-weight: 500;
  }
`;

const InventoryStatus = styled.div`
  display: flex;
  min-height: 280px;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #9299a1;
  font-size: 10px;
  text-align: center;
`;

const TrendPanelHeader = styled.header`
  display: flex;
  min-height: 66px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 18px;
  border-bottom: 1px solid #edf0f2;
  background: #fff;
`;

const TrendTitleGroup = styled.div`
  min-width: 0;
`;

const TrendTitle = styled.div`
  margin-bottom: 4px;
  color: #333;
  font-size: 14px;
  font-weight: 800;
`;

const TrendDescription = styled.div`
  color: #9299a1;
  font-size: 10px;
  line-height: 1.4;
`;

const TrendChartStack = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const TrendChartLayer = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

const MetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 14px 18px 8px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 3px;
  }
`;

const MetricButton = styled.button`
  display: flex;
  min-width: 0;
  min-height: 56px;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid ${({$active, $seriesColor}) => ($active ? $seriesColor : "#e7ebef")};
  border-radius: 9px;
  background: ${({$active}) => ($active ? "#fff" : "#fafbfc")};
  color: #555e68;
  font-size: 11px;
  font-weight: 600;
  text-align: left;
  opacity: ${({$active}) => ($active ? 1 : .62)};
  box-shadow: ${({$active, $seriesColor}) => ($active ? `inset 3px 0 0 ${$seriesColor}` : "none")};
  transition: border-color .15s ease, background .15s ease, opacity .15s ease;

  &:hover {
    background: #f7f9fc;
    opacity: 1;
  }

  &:focus-visible {
    outline: 1px solid ${({$seriesColor}) => $seriesColor};
    outline-offset: 1px;
  }
`;

const MetricColorDot = styled.span`
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border: 1px solid ${({$seriesColor}) => $seriesColor};
  border-radius: 2px;
  background: ${({$active, $seriesColor}) => ($active ? $seriesColor : "#fff")};
`;

const MetricText = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;

  & > span {
    color: #555e68;
    font-size: 10px;
    font-weight: 650;
  }

  small {
    overflow: hidden;
    color: #2f3741;
    font-size: 14px;
    font-weight: 800;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const ChartEmptyState = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #9299a1;
  text-align: center;

  strong {
    margin-bottom: 6px;
    color: #555e68;
    font-size: 12px;
  }

  span {
    font-size: 9px;
  }
`;

const ChartEmptyIcon = styled.span`
  display: inline-flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  margin-bottom: 11px;
  border-radius: 50%;
  background: #f3f5f7;
  color: #a2a9b1;

  svg {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.6;
  }
`;

const ChartTooltip = styled.div`
  background: #fff;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: center;
  & .date {
    color: #444;
    font-weight: 600;
    margin-bottom: 3px;
  }
`

const DashboardContainer = styled(BoardContainer)`
  min-width: 0;
  padding: 30px 32px 40px;
  margin: 0;
  border-radius: 0;
  background: #f4f6f9;

  ${DashBoardCard} {
    margin-bottom: 16px;
    padding: 0;
    overflow: hidden;
    border: 1px solid #e5e8eb;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 6px 20px rgba(31, 41, 55, .05);
  }

  ${DashBoardHeader} {
    position: relative;
    display: flex;
    min-height: 52px;
    align-items: center;
    margin: 0;
    padding: 0 18px 0 31px;
    border-bottom: 1px solid #edf0f2;
    color: #333b45;
    font-size: 12px;
    font-weight: 700;

    &::before {
      position: absolute;
      top: 50%;
      left: 18px;
      width: 4px;
      height: 18px;
      border-radius: 3px;
      background: ${({theme}) => theme.color.subColor};
      content: "";
      transform: translateY(-50%);
    }
  }

  ${DashBoardBody} {
    padding: 16px 18px 18px;
  }

  ${RevenueBoard} {
    min-height: 72px;
    padding: 13px 16px;
    border: 1px solid var(--theme-primary-soft-hover);
    background: linear-gradient(135deg, var(--theme-primary-soft) 0%, var(--theme-primary-softest) 100%);
    box-shadow: none;
    color: #1e3a5f;

    .won {
      color: #172554;
    }
  }

  ${DailyBoard} {
    gap: 8px;
    margin-top: 13px;

    & > div {
      min-width: 0;
      padding: 7px 10px;
      border-left: 2px solid var(--theme-primary-border);
      color: #64748b;
      font-size: 10px;
    }

    ${Price} {
      margin-top: 5px;
      color: #334155;
      font-size: 13px;
    }
  }

  ${DashBoardBodyColSpan} {
    gap: 10px;
    padding: 16px 18px 18px;

    & > div:nth-child(1),
    & > div:nth-child(2),
    & > div:nth-child(3),
    & > div:nth-child(4) {
      border: 1px solid var(--theme-primary-soft-hover);
      background: var(--theme-primary-softest);
      color: #334155;
    }
  }

  ${ColoredBox} {
    min-height: 125px;
    padding: 14px;

    img {
      width: 36px;
      height: 36px;
      object-fit: contain;
    }

    ${Price} {
      color: #172554;
      font-size: 17px;
    }
  }

  ${LastThirtyDaysItem} {
    min-width: 0;
    min-height: 75px;
    border-color: #edf0f2;

    & > div:first-child {
      width: 48px;
      height: 48px;
      flex: 0 0 48px;
      border: 1px solid #e5eaf0;
      border-radius: 12px;
      background: #f8fafc;

      img {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }

    ${BigPrice} {
      margin-top: 4px;
      color: #263241;
      font-size: 16px;
    }
  }

  ${PieChartContainer} {
    height: 230px;
    overflow: hidden;
    border-color: #e7ebef;
    background: #fff;
  }

  ${PieChartTap} {
    width: 24%;
    min-width: 82px;
    border-right-color: #edf0f2;
    background: #fafbfc;

    & > div {
      margin: 4px 0;
      padding: 10px 4px;
      border-right-width: 3px;
      color: #77808c;
      font-size: 10px;
    }
  }

  ${PieChart} {
    min-width: 0;
    flex: 1;
  }

  ${ChartContainer} {
    margin-top: 40px;
    height: 300px !important;
  }

  ${ChartLabel} {
    gap: 8px;
    padding: 8px 16px 0;
    border-bottom: 1px solid #edf0f2;
    background: #fafbfc;

    & > div {
      height: 38px;
      padding: 0 12px;
      border-radius: 6px 6px 0 0;
    }
  }

  @media (max-width: 760px) {
    padding: 18px 14px;

    ${DashBoardHeader} {
      padding-right: 14px;
    }

    ${DashBoardBody} {
      padding: 14px;
    }

    ${DailyBoard} {
      align-items: stretch;
      flex-direction: column;
    }

    ${DashBoardBodyColSpan} {
      flex-direction: column;
      padding: 14px;
    }

    ${ColoredBox} {
      min-height: 94px;
    }

    ${DashBoardWrap} {
      & > div {
        width: 100%;
      }
    }

    ${PieChartContainer} {
      height: 280px;
      flex-direction: column;
    }

    ${PieChartTap} {
      width: 100%;
      min-height: 48px;
      flex-direction: row;
      padding: 0;
      border-right: 0;
      border-bottom: 1px solid #edf0f2;

      & > div {
        margin: 0;
        border-right: 0 !important;
        border-bottom: 3px solid transparent;
      }
    }

    ${PieChartCentered} {
      height: 230px;
    }

    ${ChartLabel} {
      overflow-x: auto;
    }
  }
`

const DashboardTitleArea = styled.div`
  min-width: 0;

  & h1 {
    margin: 0;
    color: #20242b;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -.6px;
  }
`

const DashboardTitleContainer = styled(TitleContainer)`
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;

  @media (max-width: 560px) {
    flex-direction: column;
  }
`

const DashboardDescription = styled.p`
  margin: 7px 0 0;
  color: #737e89;
  font-size: 11px;
  line-height: 1.5;
`

const CreateInventoryButton = styled(Link)`
  display: inline-flex;
  min-width: 104px;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 15px;
  border: 1px solid ${({theme}) => theme.color.subColor};
  border-radius: 7px;
  background: ${({theme}) => theme.color.subColor};
  box-shadow: 0 5px 14px var(--theme-primary-shadow);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-decoration: none;

  span {
    font-size: 16px;
    line-height: 1;
  }

  &:hover {
    background: var(--theme-primary-strong);
    color: #fff;
  }

  @media (max-width: 560px) {
    width: 100%;
  }
`;

const DashboardFilterPanel = styled.section`
  display: flex;
  min-height: 54px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 9px;
  margin-left: auto;
  margin-top: 0;
  margin-bottom: 22px;
  padding: 10px;
  border: 1px solid #e1e6eb;
  border-radius: 11px;
  background: #eef1f5;

  @media (max-width: 1040px) {
    align-items: flex-end;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  @media (max-width: 640px) {
    width: 100%;
    align-items: stretch;
    justify-content: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`;

const FilterField = styled.div`
  display: flex;
  height: 48px;
  min-width: 0;
  align-items: center;
  gap: 9px;
  padding: 0 10px;
  border: 1px solid #dce2e8;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(31, 41, 55, .04);

  ${({$media}) => $media && `
    min-width: 220px;
  `}

  ${({$date}) => $date && `
    min-width: 350px;

    & > div {
      width: 260px;
    }

    .react-datepicker-wrapper input {
      height: 46px;
      border: 0;
      background: transparent;
      box-shadow: none;
      white-space: nowrap;
    }
  `}

  @media (max-width: 640px) {
    width: 100%;
    min-width: 0;

    & > div {
      width: 100%;
    }
  }
`;

const FilterControlIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  color: var(--theme-primary);

  svg {
    width: 17px;
    height: 17px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.7;
  }
`;

const FilterLabel = styled.label`
  flex: 0 0 auto;
  color: #34404d;
  font-size: 10px;
  font-weight: 750;
  white-space: nowrap;
`;

const controlStyle = `
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dfe3e7;
  border-radius: 7px;
  background-color: #fff;
  color: #4b5563;
  font-size: 10px;
  outline: none;
`;

const DashboardSelect = styled.select`
  ${controlStyle}
  min-width: 120px;
  flex: 1;
  padding: 0 30px 0 4px;
  border: 0;
  background-color: transparent;
  box-shadow: none;

  &:focus {
    box-shadow: none;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`;

const FilterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-left: 0;

  @media (max-width: 640px) {
    margin-left: 0;
  }
`;

const FilterResetButton = styled.button`
  display: inline-flex;
  min-width: 76px;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 12px;
  border: 1px solid #dfe3e7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(31, 41, 55, .04);
  color: #68717c;
  font-size: 10px;
  font-weight: 650;

  svg {
    width: 14px;
    height: 14px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.8;
  }

  &:hover {
    border-color: var(--theme-primary-border);
    background: var(--theme-primary-soft);
    color: ${({theme}) => theme.color.subColor};
  }
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 18px;
  margin-top: 0;
  margin-bottom: 18px;

  & > div {
    width: 100%;
    min-width: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;

    & > div:last-child {
      grid-column: auto;
    }
  }
`

const DashboardSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 22px 0 13px;
  padding-left: 12px;

  &::before {
    position: absolute;
    top: 1px;
    bottom: 1px;
    left: 0;
    width: 4px;
    border-radius: 3px;
    background: var(--theme-primary);
    content: "";
  }

  & > div {
    display: flex;
    min-width: 0;
    align-items: baseline;
    gap: 10px;
  }

  strong {
    color: #202832;
    font-size: 15px;
    font-weight: 800;
  }

  span {
    color: #9299a1;
    font-size: 10px;
  }

  @media (max-width: 620px) {
    & > div {
      align-items: flex-start;
      flex-direction: column;
      gap: 5px;
    }
  }
`;

const RevenueFullRow = styled.div`
  grid-column: 1 / -1;
  min-width: 0;

  ${DashBoardCard} {
    margin-bottom: 0;
  }

  ${DashBoardBody} {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: stretch;
    gap: 10px;
  }

  ${DailyBoard} {
    display: contents;
    margin-top: 0;

    & > div {
      min-height: 96px;
      justify-content: center;
      padding: 14px 16px;
      border: 1px solid #e7ebef;
      border-left: 1px solid #e7ebef;
      border-radius: 9px;
      background: #f8fafc;
      color: #727d89;
      font-size: 10px;
    }

    ${Price} {
      margin-top: 8px;
      color: #2f3945;
      font-size: 18px;
      font-weight: 800;
    }
  }

  ${RevenueBoard} {
    min-height: 96px;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    padding: 14px 16px;
    border-color: var(--theme-primary-border);
    background: linear-gradient(135deg, var(--theme-primary-soft) 0%, var(--theme-primary-softest) 100%);
    box-shadow: inset 4px 0 0 var(--theme-primary);
    color: #536174;

    & > div:first-child {
      margin-bottom: 7px;
      font-size: 10px;
      font-weight: 650;
    }

    & > div:last-child {
      width: 100%;
      justify-content: space-between;
    }

    .won {
      color: var(--theme-primary-strong);
      font-size: 22px;
      font-weight: 850;
    }

  }

  @media (max-width: 860px) {
    ${DashBoardBody} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 520px) {
    ${DashBoardBody} {
      grid-template-columns: 1fr;
    }
  }
`;

const revenueChangeTone = {
  up: {
    color: "var(--accent-red)",
    background: "var(--accent-red-soft)",
    border: "var(--accent-red-border)"
  },
  down: {
    color: "#1D4ED8",
    background: "#DBEAFE",
    border: "#93C5FD"
  },
  flat: {
    color: "#64748B",
    background: "#F1F5F9",
    border: "#CBD5E1"
  }
};

const RevenueChangeBadge = styled.div`
  display: inline-flex;
  width: auto !important;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center !important;
  gap: 5px;
  padding: 0 9px;
  border: 1px solid ${({$direction}) => revenueChangeTone[$direction].border};
  background: ${({$direction}) => revenueChangeTone[$direction].background};
  color: ${({$direction}) => revenueChangeTone[$direction].color};
  font-size: 9px;
  white-space: nowrap;

  span {
    color: inherit;
    font-weight: 600;
    opacity: .78;
  }

  strong {
    color: inherit;
    font-size: 10px;
    font-weight: 800;
  }
`;

const RevenueChangeIcon = styled.svg.attrs({viewBox: "0 0 24 24"})`
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  transform: ${({$direction}) => ($direction === "down" ? "rotate(180deg)" : "none")};
`;

const statusIconTones = {
  request: {color: "var(--accent-red)", background: "var(--accent-red-soft)"},
  exposure: {color: "var(--accent-orange)", background: "var(--accent-orange-soft)"},
  revenue: {color: "var(--accent-green)", background: "var(--accent-green-soft)"},
  rate: {color: "var(--accent-yellow)", background: "var(--accent-yellow-soft)"},
};

const StatusMetricIcon = styled.span`
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: ${({$type}) => (statusIconTones[$type] || statusIconTones.request).background};
  color: ${({$type}) => (statusIconTones[$type] || statusIconTones.request).color};

  svg {
    width: 18px;
    height: 18px;
  }
`;

const DashboardLoading = styled.div`
  display: flex;
  width: 100%;
  min-height: 150px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  color: #7a8591;
  font-size: 10px;
`;

const LoadingSpinner = styled.i`
  width: 24px;
  height: 24px;
  border: 3px solid var(--theme-primary-soft-hover);
  border-top-color: var(--theme-primary);
  border-radius: 50%;
  animation: dashboard-loading-spin .7s linear infinite;

  @keyframes dashboard-loading-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const UserStatusCard = styled(DashBoardCard)`
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  box-shadow: 0 5px 18px rgba(31, 41, 55, .04);

  ${DashBoardHeader} {
    min-height: 54px;
    border-bottom: 1px solid #edf0f2;
    background: #fff;
    color: #333;
    font-size: 12px;
    font-weight: 750;
  }

  ${DashBoardBody} {
    padding: 12px 14px 16px;
  }

  .InovuaReactDataGrid--theme-default-light {
    overflow: hidden;
    border: 1px solid #dfe5eb;
    border-radius: 8px;
    background: #fff;
    font-size: 11px;
  }

  .InovuaReactDataGrid__header,
  .InovuaReactDataGrid__column-header {
    border-color: #cddff5 !important;
    background: #f2f7fd;
  }

  .InovuaReactDataGrid__header {
    border-bottom: 2px solid #8bb8ea !important;
  }

  .InovuaReactDataGrid__column-header {
    color: #34475a;
    font-size: 11px;
    font-weight: 750;
  }

  .InovuaReactDataGrid__row {
    border-color: #edf1f4 !important;
    color: #46515d;
    font-size: 11px;
  }

  .InovuaReactDataGrid__cell {
    border-color: #edf1f4 !important;
    padding-right: 12px;
    padding-left: 12px;
    font-size: 11px;
  }

  @media (max-width: 720px) {
    ${DashBoardBody} {
      padding: 8px;
    }
  }
`;

const NoticeStatusCard = styled(DashBoardCard)`
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  box-shadow: 0 5px 18px rgba(31, 41, 55, .04);

  ${DashBoardHeader} {
    min-height: 54px;
    border-bottom: 1px solid #edf0f2;
    background: #fff;
    color: #333;
    font-size: 12px;
    font-weight: 750;
  }

  ${DashBoardBody} {
    padding: 4px 14px 10px;
  }

  .InovuaReactDataGrid--theme-default-light {
    overflow: hidden;
    border: 0;
    background: #fff;
    font-size: 11px;
  }

  .InovuaReactDataGrid__row {
    border-color: #edf1f4 !important;
    transition: background .15s ease;
  }

  .InovuaReactDataGrid__row:hover {
    background: #f7fbff !important;
  }

  .InovuaReactDataGrid__cell {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 11px;
  }

  a {
    color: #27313c;
    font-weight: 700;
    text-decoration: none;
  }

  a:hover {
    color: var(--theme-primary-strong);
    text-decoration: underline;
  }

  p {
    width: 100%;
    margin: 0;
    color: #9aa3ad;
    font-size: 10px;
    text-align: right;
  }

  @media (max-width: 720px) {
    ${DashBoardBody} {
      padding: 4px 8px 8px;
    }
  }
`;

const StatusCardColumn = styled.div`
  min-width: 0;

  ${DashBoardCard} {
    height: 100%;
    margin-bottom: 0;
    border-color: ${({$featured}) => ($featured ? "var(--theme-primary-border-strong)" : "#e5e8eb")};
    box-shadow: ${({$featured}) => (
      $featured
        ? "0 8px 24px var(--theme-primary-strong-shadow)"
        : "0 5px 18px rgba(31, 41, 55, .04)"
    )};
  }

  ${DashBoardHeader} {
    min-height: 56px;
    background: ${({$featured}) => (
      $featured
        ? "linear-gradient(135deg, var(--theme-primary-soft) 0%, var(--theme-primary-softest) 100%)"
        : "#fafbfc"
    )};
    color: ${({$featured}) => ($featured ? "var(--theme-primary-strong)" : "#333")};
    font-weight: ${({$featured}) => ($featured ? 800 : 700)};

  }

  ${DashBoardBodyColSpan} {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: 8px;
  }

  ${ColoredBox} {
    min-height: 112px;
    padding: 12px;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr);
    grid-template-rows: auto auto;
    align-content: center;
    column-gap: 10px;
    border: 1px solid #e8edf2;
    border-radius: 9px;
    background: ${({$featured}) => ($featured ? "var(--theme-primary-softest)" : "#fff")};
    color: #77818d;
    text-align: left;

    ${StatusMetricIcon} {
      grid-row: 1 / 3;
    }

    & > div:not(${Price}) {
      font-size: 10px;
      font-weight: 650;
    }

    ${Price} {
      margin-top: 5px;
      color: #2f3945;
      font-size: 16px;
      font-weight: 800;
    }
  }

  ${DashBoardWrap} {
    display: grid;
    height: auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;

    & > div {
      width: 100%;
    }
  }

  ${LastThirtyDaysItem} {
    min-height: 112px;
    padding: 12px;
    border: 1px solid #e8edf2;
    border-radius: 9px;
    background: #fff;

    & > div:first-child {
      width: 36px;
      height: 36px;
      flex: 0 0 36px;
      border: 0;
      border-radius: 0;
      background: transparent;
    }

    & > div:last-child {
      min-width: 0;
      padding-left: 10px;

      & > div:first-child {
        color: #77818d;
        font-size: 10px;
        font-weight: 650;
      }
    }

    ${BigPrice} {
      margin-top: 5px;
      color: #2f3945;
      font-size: 16px;
      font-weight: 800;
    }
  }
`;

const RevenueShareColumn = styled.div`
  height: 340px;
  min-width: 0;

  ${DashBoardCard} {
    height: 100%;
    margin-bottom: 0;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(31, 41, 55, .055);
  }

  ${DashBoardHeader} {
    min-height: 48px;
    padding-top: 0;
    padding-bottom: 0;
    background: #fafbfc;
    font-size: 11px;
  }

  ${DashBoardBody} {
    padding: 10px;
  }

  ${RevenueShareGrid} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  ${RevenueDonutLayout} {
    height: 242px;
    grid-template-columns: 1fr;
    grid-template-rows: 158px minmax(0, 1fr);
    align-items: start;
    gap: 4px;
    padding: 4px 8px 10px;
  }

  ${RevenueLegend} {
    gap: 1px;
  }

  ${RevenueLegendItem} {
    min-height: 18px;
    padding: 0 4px;
  }

  ${DonutCenter} {
    width: 82px;

    strong {
      font-size: 14px;
    }
  }

  @media (max-width: 560px) {
    ${RevenueShareGrid} {
      grid-template-columns: 1fr;
    }
  }
`;
